import { Box, CircularProgress } from '@mui/material'

function TableLoadingOverlay() {
  return (
    <Box
      sx={{
        position: 'absolute',
        inset: 0,
        bgcolor: 'rgba(255,255,255,0.6)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1,
      }}
    >
      <CircularProgress size={28} sx={{ color: '#11809A' }} />
    </Box>
  )
}

export default TableLoadingOverlay
